/**
 * Analytics & Cookie Consent
 *
 * UK GDPR + PECR requires explicit consent before loading analytics.
 * All analytics scripts MUST be loaded through loadAnalytics() — never
 * add <script> tags directly to index.html as that bypasses consent.
 *
 * How to add Google Analytics:
 *   1. Get your GA4 Measurement ID (G-XXXXXXXXXX)
 *   2. Uncomment the GA section in loadAnalytics() below
 *   3. Update src/components/legal/content/cookies.md if the cookie names change
 *
 * How to add Grafana Faro:
 *   1. Set up a Faro collector endpoint
 *   2. Uncomment the Faro section in loadAnalytics() below
 *   3. npm install @grafana/faro-web-sdk
 *
 * Cookie-free analytics (e.g. Cloudflare Web Analytics):
 *   These do NOT require consent and can be added directly to index.html.
 *   But update the Cookie Policy to mention them.
 *
 * NEVER use Google Tag Manager auto-inject mode — it bypasses consent.
 */

const CONSENT_KEY = "cosx-cookie-consent";

export function getConsent(): "accepted" | "declined" | null {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    if (v === "accepted" || v === "declined") return v;
  } catch {}
  return null;
}

export function setConsent(value: "accepted" | "declined") {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {}
}

export function resetConsent() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch {}
}

let analyticsLoaded = false;

/**
 * Load analytics scripts. Only called after user accepts cookies.
 * Add all tracking scripts here — this is the single entry point.
 */
export function loadAnalytics() {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  // ── Google Analytics (GA4) ──
  // const GA_ID = "G-XXXXXXXXXX";
  // const script = document.createElement("script");
  // script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  // script.async = true;
  // document.head.appendChild(script);
  // window.dataLayer = window.dataLayer || [];
  // function gtag(...args: unknown[]) { window.dataLayer.push(args); }
  // gtag("js", new Date());
  // gtag("config", GA_ID, { anonymize_ip: true });

  // ── Grafana Faro ──
  // import("@grafana/faro-web-sdk").then(({ initializeFaro }) => {
  //   initializeFaro({
  //     url: "https://your-faro-collector.example.com/collect",
  //     app: { name: "cosx-website", version: "1.0.0" },
  //   });
  // });

  if (import.meta.env.DEV) {
    console.log("[analytics] consent accepted, scripts loaded (placeholder)");
  }
}
